export const isMobileDevice = function () {
    const savedIsMobile = localStorage.isMobile;
    if (savedIsMobile) {
        return savedIsMobile;
    } else {
        const ua = window.navigator.userAgent;
        const isMobileTest = /Mobi|Android/i.test(ua);
        const isIPad = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(ua);

        const isMobile = (isMobileTest || isIPad);
        if (isMobile) { // if initial view is mobile, save this in case user changes ua later via "Request Desktop Website"
            localStorage.setItem('isMobile', isMobile);
        }
        return isMobile;
    }
}
